import { PartnerRequestType } from "./../redux/slices/partnerRequest/index";
import { partnerRequestActions } from "redux/slices/partnerRequest";
import http from "./http.service";
import Promisable from "./promisable.service";
import { modalActions } from "redux/slices/modal";
import { NavigateFunction } from "react-router-dom";
import { loaderActions } from "redux/slices/loader";
import { getAppDispatch } from "utils/dispatch.util";
import { partnerActions } from "redux/slices/partner";
import { formLoaderActions } from "redux/slices/formLoader";

const url = "/partner";

const PartnerService = {
  addPartner: async (data: any, navigate?: NavigateFunction) => {
    const dispatch = getAppDispatch();
    dispatch?.(formLoaderActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}`, data)
    );

    if (success) {
      const { partner } = success.data.data;
      dispatch?.(partnerActions.addPartner(partner));
      navigate?.(`/partner-details/${partner._id}`);
    }

    dispatch?.(formLoaderActions.setLoading(false));
    return [success, error];
  },
  updatePartner: async (id: string, data: any, navigate?: NavigateFunction) => {
    const dispatch = getAppDispatch();
    dispatch?.(formLoaderActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.patch(`${url}/${id}`, data)
    );

    if (success) {
      const { partner } = success.data.data;
      dispatch?.(partnerActions.updatePartner({ id, partner }));
      navigate?.(`/partner-details/${id}`);
    }

    dispatch?.(formLoaderActions.setLoading(false));
    return [success, error];
  },
  getPartner: async (id: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(loaderActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/${id}`)
    );

    if (success) {
      const { partner } = success.data.data;
      dispatch?.(partnerActions.setPartner(partner));
    } else dispatch?.(partnerActions.setPartner({ data: "Not Found" }));

    dispatch?.(loaderActions.setLoading(false));
    return [success, error];
  },
  getAllPartners: async (id?:string) => {
		const query = id ? id : ""
    const dispatch = getAppDispatch();
    dispatch?.(partnerActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}${query}`)
    );

    if (success) {
      const { partners } = success.data.data;
      dispatch?.(partnerActions.setPartners(partners));
    }

    dispatch?.(partnerActions.setLoading(false));
    return [success, error];
  },
  updatePartnerStatus: async (id: string, data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/status/${id}`, data)
    );

    if (success) {
      const { partner } = success.data.data;
      dispatch?.(partnerActions.setPartner(partner));
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  uploadPartnerDocs: async (id: string, data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/upload/${id}`, data)
    );

    if (success) {
      const { partner } = success.data.data;
      dispatch?.(partnerActions.setPartner(partner));
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  updatePartnerDocsStatus: async (id: string, data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/document/status/${id}`, data)
    );

    if (success) {
      const { partner } = success.data.data;
      dispatch?.(partnerActions.setPartner(partner));
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  getPartnerRequests: async (type: PartnerRequestType) => {
    const dispatch = getAppDispatch();
    dispatch?.(partnerRequestActions.setLoading({ type, loading: true }));
    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.get(`partner-requests/${type}`)
    );
    if (success) {
      const partnerRequests = success.data.data.requests;
      dispatch?.(
        partnerRequestActions.setPartnerRequests({ type, partnerRequests })
      );
    }
    dispatch?.(partnerRequestActions.setLoading({ type, loading: false }));
    return [success, error];
  },

  deletePartnerRequest: async (type: PartnerRequestType, id: string,closed_reason:any) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));
    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`partner-requests/update-status/${id}`,{closed_reason:closed_reason})
    );
    if (success) {
      const { partner_request } = success.data.data;
      dispatch?.(modalActions.closeModal());
      PartnerService?.getPartnerRequests(type)
      // dispatch?.(
      //   partnerRequestActions.updatePartnerRequest({
      //     type,
      //     partnerRequest: partner_request,
      //   })
      // );
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  checkDocumentsExpiry: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/update-expiry`)
    );

    if (success) dispatch?.(modalActions.closeModal());

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
};

export default PartnerService;
